/**
 * Debounce a function for performance.
 *
 * @param {function} func     The function.
 * @param {Number} wait       The delay.
 * @param {Boolean} immediate Invoked on tail end if true.
 */
const debounce = ( func, wait, immediate ) => {
	let timeout;
	return function() {
		const context = this;
		const args = arguments;
		const later = function() {
			timeout = null;
			if ( !immediate ) func.apply( context, args );
		};
		const callNow = immediate && !timeout;
		clearTimeout( timeout );
		timeout = setTimeout( later, wait );
		if ( callNow ) func.apply( context, args );
	};
}
